import OrderDetailsHeader from '../commons/orders/OrderDetailsHeader';

import '../style/OrderHistorial.css';



const OrderDetails = () => {

  return (
    <div className='orderContainer4'>
      <OrderDetailsHeader />
    </div>
  );
};

export default OrderDetails;